import { computed, watch, inject } from 'vue'
import { usePage } from '@inertiajs/vue3'

interface Toast {
  success: (message: string) => void
  error: (message: string) => void
}

const useFlashToaster = (): void => {
  const page = usePage()
  const errorCount = computed(() =>
    typeof page.props.errors === 'string' ? 0 : Object.keys(page.props.errors).length,
  )
  const hasSuccess = computed(() => page.props.success)
  const hasError = computed(() => page.props.errors || errorCount.value > 0)
  const $toast = inject<Toast>('$toast')

  watch(
    hasSuccess,
    () => {
      if (page.props.success && $toast) {
        $toast.success(page.props.success as string)
      }
    },
    { deep: true },
  )

  watch(
    hasError,
    () => {
      if (page.props.errors && $toast) {
        if (errorCount.value > 0) {
          $toast.error(
            `Le formulaire comporte ${errorCount.value === 1 ? 'une' : errorCount.value} erreur${errorCount.value > 1 ? 's' : ''}.`,
          )
        } else if (typeof page.props.errors === 'string') {
          $toast.error(page.props.errors)
        }
      }
    },
    { deep: true },
  )
}

export { useFlashToaster }
